/** Mock辅助工具 */

import type { PaginatedResponse } from '../types';

/** 模拟网络延迟 */
export function delay(ms: number = 300): Promise<void> {
  const jitter = Math.random() * 200;
  return new Promise((resolve) => setTimeout(resolve, ms + jitter));
}

/** 生成随机ID */
export function generateId(prefix: string = ''): string {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  return `${prefix}${timestamp}${random}`.toUpperCase();
}

/** 生成随机数字 */
export function randomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/** 生成随机浮点数 */
export function randomFloat(min: number, max: number, decimals: number = 2): number {
  const value = Math.random() * (max - min) + min;
  return parseFloat(value.toFixed(decimals));
}

/** 从数组中随机选取一个元素 */
export function randomPick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

/** 从数组中随机选取多个元素 */
export function randomPickMultiple<T>(arr: T[], count: number): T[] {
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

/** 模拟分页响应 */
export function paginate<T>(data: T[], page: number, pageSize: number): PaginatedResponse<T> {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  return {
    code: 0,
    message: 'success',
    data: data.slice(start, end),
    total: data.length,
    page,
    pageSize,
  };
}

/** 生成时间戳（过去N天内随机时间） */
export function randomTimestamp(daysAgo: number = 30): string {
  const now = Date.now();
  const offset = Math.random() * daysAgo * 24 * 60 * 60 * 1000;
  return new Date(now - offset).toISOString();
}
